// extracted by mini-css-extract-plugin
module.exports = {"futureCheckbox":"FutureCheckbox__futureCheckbox__7LcRM","input":"FutureCheckbox__input__kE0wS","ui":"FutureCheckbox__ui__TgfB3"};